exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ruku[data-v-7883aa52] {\r\n    color: #909399;\n}\n.filter-container[data-v-7883aa52] .el-card__body{\r\n    padding: 10px;\n}\r\n", ""]);

// exports
